const fr: Record<string, string> = {
    otherGames: 'Autres jeux',
    createGame: 'Créer la partie',
    join: 'Rejoindre',
    joinError: 'Impossible de rejoindre la partie',
    pseudo: 'Pseudo',
    turn: 'Tour',
    confirmChoice: 'Valider le choix?',
    thinking: 'est en train de réfléchir...',
    waitingBets: 'En attente des autres paris ...',
    endTurn: 'Fin du tour?',
    yourBet: 'A vous de parier!',
    winnerIs: "C'est {name} qui a gagné!",
    youWon: 'Tu as gagné!',
    nobodyWon: "Personne n'a gagné :o",
    clickCardToContinue: 'Clique sur la carte pour continuer',
    waitingForTurnHolder: 'En attente de {name}...',
    won: 'Gagné!',
    newTurn: 'Nouveau tour?',
    newGame: 'Nouvelle partie',
    code: 'Code',
    invite: 'Inviter',
    linkCopied: 'Lien copié !',
    connectedPlayers: 'Joueurs connectés:',
    waitingOrganizer: "En attente de l'organisateur",
    playlist: 'Playlist',
    Rock: 'Rock',
    playlistPop: 'Pop',
    'Best Hit - France': 'Best Hit - France',
    '100% France': '100% France',
    'Plaisirs coupables': 'Plaisirs coupables',
    'Rock - Deutschland': 'Rock - Deutschland',
    'Best Hit - USA': 'Best Hit - USA',
    playlistSummerParty: 'Summer Party',
    playlistHipHop: 'Hip-Hop',
    playlist80s: 'Années 80',
    playlistJazz: 'Jazz',
    playlistElectro: 'Electro',
    country_france: 'France',
    country_usa: 'États-Unis',
    country_deutschland: 'Allemagne',
    yourTurn: 'A ton tour, {name}!',
    yourTurnPrefix: 'A ton tour, ',
    turnOfPrefix: 'Tour de ',
    turnOfSuffix: '',
    fatalError: 'Une erreur fatale est survenue.',
    sendError: "Merci de m'indiquer vos actions et de m'envoyer ce message:",
    reloadGame: 'Il faut recharger la partie :c',
    backToHome: "Retourner à l'accueil",
    codedBy: 'Codé avec amour par',
    thanks: 'Remerciements',
    seeGames: 'Site internet',
    home: 'Accueil',
    menu: 'Menu :)',
    readyConfirm: 'Tour ok pour moi?',
    waitingReady: 'En attente...',
    waitingForPlayers: 'En attente de : {names}',
    playlistExhausted: 'épuisée !',
    playlistSwitched: 'Playlist {old} épuisée ! Passage à {new}',
    cardsToWin: 'Cartes pour gagner',
    gameOver: '{name} a gagné la partie !',
    backToHomeButton: "Retour à l'accueil",
    disclaimer: 'Ce jeu est un projet personnel non affilié à Hitster.',
    copyright: 'Hitster est la propriété intellectuelle de © 2022 Koninklijke Jumbo B.V. | © game concept by Slættaratindur AB & Friends.',
};

export default fr;
